import type { CSSProperties } from 'react'
import type { ECharts, EChartsOption } from 'echarts'
import type { MergeWithCustomizer } from 'lodash'
import type { ChartEvts } from './declare'
import { useEffect, useMemo, useRef } from 'react'
import { EasyECharts } from 'src/components'
import { mergeWith } from 'lodash'

type Props = {
  notMerge?: boolean,
  lazyUpdate?: boolean,
  chartData?: any,
  extraOption?: EChartsOption, // effect 渲染后的 setOption
  mergeOption?: EChartsOption, // memo 运行时 merge 的option
  mergeWith?: MergeWithCustomizer,
  onChartReady?: Function,
  autoPlay?: boolean,
  autoPlayTime?: number,
  onEvts?: ChartEvts,
  style?: CSSProperties
}

const ChartPie = (props: Props) => {
  const chart = useRef<ECharts>()
  const handleChartReady = (chartInstance: any) => {
    chart.current = chartInstance
    props.onChartReady?.(chartInstance)
  }
  useEffect(() => {
    if (props.extraOption && chart.current) {
      chart.current!.setOption(props.extraOption!, undefined, true)
    }
  }, [props.extraOption])

  const dataOption = useMemo<any>(() => {
    if (!props.chartData) return undefined

    const { Name = '', XAxis = [], Data = [] } = props.chartData
    const legend: any = {
      type: 'scroll',
      orient: 'vertical',
      right: 0,
      pageIconSize: 10,
      data: XAxis[0].Data
    }
    const tooltip = {
      trigger: 'item',
      formatter: function (params: any) {
        if (params.seriesName) return `${params.seriesName}<br />${params.name}：${params.value}（${params.percent}%）`
        return `${params.name}<br />当前值：${params.value}<br />占比：${params.percent}%`
      }
    }
    const series = [
      {
        name: Name,
        type: 'pie',
        radius: ['50%', '70%'],
        center: ['40%', '50%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true
          }
        },
        labelLine: {
          show: false
        },
        data: []
      }
    ]
    series[0].data = legend.data.map((item: any, index: number) => {
      const { Value } = Data[0].Data[index]
      return {
        name: item,
        value: Value,
      }
    })

    return {
      legend,
      tooltip,
      series
    }
  }, [props.chartData])

  const chartOption = useMemo(() => {
    if (!props.mergeOption) return dataOption
    return mergeWith(dataOption, props.mergeOption, props.mergeWith)
  }, [dataOption, props.mergeOption])

  return (
    <EasyECharts
      notMerge={props.notMerge ?? true}
      lazyUpdate={props.lazyUpdate ?? true}
      autoPlay={props.autoPlay}
      autoPlayTime={props.autoPlayTime}
      option={chartOption}
      onChartReady={handleChartReady}
      onEvents={props.onEvts}
      style={props.style}
    />
  )
}

export default ChartPie